import { AssetLoaderCssFactory } from 'common/module/asset/loader/css.factory';
import { AssetLoaderCssServiceInterface } from 'common/service/asset-loader-css/service.interface';

const assetLoaderCssService = AssetLoaderCssFactory();

export function AssetLoaderCssService(): AssetLoaderCssServiceInterface {
  return assetLoaderCssService;
}
